<div class="modal">
  <p> Abos werden mit heutigem Datum geschlossen, falls der Kunde nicht bereits die Bestellung abgeschlossen hat</p>
  <button mat-button (click)="closeOpenDraftOrdersForToday()">Schließe offene Bestellungen</button>
</div>
